// @flow

import * as React from "react";
// import { Switch, Route, Redirect, NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";

// import Config from "../constants/Config";
import actions from "../actions/index.js";
import { getProfile, getOptIns } from "../actions/user";
import HeroProfilePage from "../components/organisms/HeroProfilePage";
import PersonalDetailsForm from "../components/organisms/PersonalDetailsForm";
import ChangePasswordForm from "../components/organisms/ChangePasswordForm";
import MarketingOptInForm from "../components/organisms/MarketingOptInForm";
import CustomMeta from "../components/atoms/CustomMeta.js";

const EditProfile = (): React.Node => {
    const dispatch = useDispatch();
    const breadcrumbs = [
        {
            title: "My account",
            onClick: () => dispatch(actions.openAccountModal()),
            type: "button",
        },
    ];

    return (
        <React.Fragment>
            <CustomMeta title="Edit Profile" />

            <HeroProfilePage heading="Edit Profile" breadcrumbs={breadcrumbs} />

            <div className="login-profile-body container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-md-offset-2 col-md-8">
                        {/* Details Form */}
                        <PersonalDetailsForm />

                        {/* Change Password Form */}
                        <ChangePasswordForm />

                        {/* Opt in form */}
                        <MarketingOptInForm />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

EditProfile.preload = ({ passed: { store }, location }: any): Promise<any> => {
    return Promise.all([
        store.dispatch(getProfile()),
        store.dispatch(getOptIns()),
    ]);
};

export default EditProfile;
